import React, { useEffect, useRef } from "react";
import { Swiper, SwiperSlide } from "swiper/react";
import { Pagination } from "swiper/modules";
import "swiper/css";
import "swiper/css/pagination";
import "./Slider.css"
import { SliderBtn } from '../Navbar/NavbarElements'


export default function Slider() {
    const swiperWrappedRef = useRef(null);

    function adjustMargin() {
        const screenWidth = window.innerWidth;

        if (swiperWrappedRef.current) {
            swiperWrappedRef.current.style.marginLeft =
            screenWidth <= 520
            ? "0px"
            : screenWidth <= 650
            ? "-50px"
            : screenWidth <= 800
            ? "-100px"
            : "-150px";
        }
    }

    useEffect(() => {
        adjustMargin();
        window.addEventListener("resize", adjustMargin);
        return () => window.removeEventListener("resize", adjustMargin);
    }, []);
    return (
        <>
        <div id='services' className='title_slider'>
            <div className='content_slider'>
                <h2>Våra tjänster</h2>
            </div>
            <div className="container_slider">
                <Swiper 
                    modules={[Pagination]}
                    z-index={-1}
                    grabCursor
                    initialSlide={3}
                    centeredSlides
                    slidesPerView="auto"
                    speed={800}
                    slideToClickedSlide
                    pagination={{clickable: true}}
                    breakpoints={{
                        320: { spaceBetween: 40 },
                        650: { spaceBetween: 30 },
                        1000: { spaceBetween: 20 }
                    }}
                    onSwiper={(Swiper) => {
                        swiperWrappedRef.current = Swiper.wrapperEl
                    }}
                >
                     <SwiperSlide>
                            <div className="img" />      
                            <div className="content">  
                                <SliderBtn to='/service'>                  
                                <div className="footer_slider">
                                <div className="btn">
                                    <span className="label">Service</span>
                                </div>
                                </div>
                                </SliderBtn> 
                            </div>
                        </SwiperSlide>  
                        <SwiperSlide>
                            <div className="img2" />      
                            <div className="content">  
                                <SliderBtn to='/consultant'>                  
                                <div className="footer_slider">
                                <div className="btn">
                                    <span className="label">Gratis konsultation</span>
                                </div>
                                </div>
                                </SliderBtn> 
                            </div>
                        </SwiperSlide>  
                        <SwiperSlide>
                            <div className="img3" />      
                            <div className="content">  
                                <SliderBtn to='/event'>                  
                                <div className="footer_slider">
                                <div className="btn">
                                    <span className="label">Eventlokaler</span>
                                </div>
                                </div>
                                </SliderBtn> 
                            </div>
                        </SwiperSlide>    
                       <SwiperSlide>
                            <div className="img4"></div>
                            <div className="content">
                                <SliderBtn to='/wedding'>
                                <div className="footer_slider">
                                <div className="btn">
                                    <span className="label">Bröllop</span>
                                </div>
                                </div>
                                </SliderBtn> 
                            </div>
                        </SwiperSlide>
                        <SwiperSlide>
                            <div className="img5"></div>
                            <div className="content">
                                <SliderBtn to='/catering'>
                                <div className="footer_slider">
                                <div className="btn">
                                    <span className="label">Catering</span>
                                </div>
                                </div>
                                </SliderBtn> 
                            </div>
                        </SwiperSlide>
                          <SwiperSlide>
                            <div className="img6" />      
                            <div className="content">  
                                <SliderBtn to='/decore'>                  
                                <div className="footer_slider">
                                <div className="btn">
                                    <span className="label">Decor</span>
                                </div>
                                </div>
                                </SliderBtn> 
                            </div>
                        </SwiperSlide>     
                        <SwiperSlide>
                            <div className="img7" />      
                            <div className="content">  
                                <SliderBtn to='/cars'>                  
                                <div className="footer_slider">
                                <div className="btn">
                                    <span className="label">Bilar</span>
                                </div>
                                </div>
                                </SliderBtn> 
                            </div>
                        </SwiperSlide>     
                </Swiper>
            </div>
        </div>
        </>
    )
}